export enum RepairRequestStatus {
  UnderReview = 'Under Review',
  Approved = 'Approved',
  Complete = 'Complete',
  Denied = 'Denied',
  Cancelled = 'Cancelled',
}
